/**
 *
 * Description: JS for EssayForSale.net
 * Version: 1.0.0
 * Last update: 2015/12/22
 * Author: UVOCorp
 *
 */

/* Shim for deprecated uvoAutocomplete. Only modifies html layout for compatibility */
$.fn.uvoAutocomplete = $.fn.uvoAutocomplete || function() {
  return this.each(function(_, el) {
    if (el.uvoAutocompleteShimInitialized) return;
    el.uvoAutocompleteShimInitialized = true;
    var $el = $(el);
    var $wrapper = $('<div class="uvo_pref-uvoAutocomplete-wrapper" />');
    var $icon = $('<span class="ui-icon ui-icon-triangle-1-s" style="position: absolute; cursor: pointer; right: 10px; top: 0px;" />');
    $el.wrap($wrapper);
    $el.after($icon);
    $el.addClass('uvo_pref-uvoAutocomplete-input');
    $el.css({ appearance: 'none', '::-ms-expand': 'none' });
    $icon.css({ pointerEvents: 'none' });
  })
};

/* =============================
 NEW CALC INIT
================================ */
  $.getScript('/assets/js/calc.js', function () {
    // CALC MINI json
  	if ($('[data-calc-mini]').length > 0 && $('.calc-mini-json').length > 0) {
			new Calc({
				ID: '133',
				calculatorType: 'DefaultCalculator',
				format: 'json',
				options: {
					deafault: {
						deadlinesDefault: [96927, 97025, 97123, 97227, 97319],
						academicLevelDefault: 2,
						paperTypesDefault: 1,
						pagesDefault: 2,
					}
				}
			});
    }

    //CALC MINI html
    if ($('[data-calc-mini]').length > 0 && $('.calc-mini-html').length > 0) {
      new Calc({
        ID: '133',
        calculatorType: 'DefaultCalculator',
        format: 'html',
        options: {
          deafault: {
            deadlinesDefault: [96927, 97025, 97123, 97227, 97319],
            academicLevelDefault: 2,
            paperTypesDefault: 1,
            pagesDefault: 2,
          }
        }
      });
    }
  });
/* =============================
  end NEW CALC INIT
================================ */

(function toggleListInit() {
  if (!document.querySelector('[data-page="frequently_asked_questions"]') && !document.querySelector('[data-page="money_back_guarantee"]')) return false;

  function toggle_list() {
    $('.toggle-list .toggle-content').addClass('hide');
    $(document).on('click', '.toggle-list .toggle-link', function(){
      if($(this).next().hasClass('hide')){ $(this).next().slideDown(500); }else{ $(this).next().slideUp(500); }
      $(this).parent().toggleClass('active');
      $(this).next().toggleClass('hide');
      return false;
    });
  }

  window.addEventListener('contentRendered', toggle_list);
})();


(function (window, document) {
  function init() {
    var element = document.getElementById('CommonPage');

    if (element) {
      var pageName = element.getAttribute('data-page');
      var siteId = element.getAttribute('data-site-id');
      var policies = element.getAttribute('data-policies');
      var policyId = element.getAttribute('data-policy-id');

      let widgetOptions = {
        siteId,
        pageName,
      };

      if (policies && policyId) {
        widgetOptions = { siteId, pageName, policies, policyId };
      }

      window.commonPagesWidget.widget(element, widgetOptions);
    }
  }

  if (typeof window.commonPagesWidget !== 'undefined') {
    init();
  } else {
    var script = document.createElement('script');
    script.src = '/assets/js/commonPagesWidget.min.js';
    script.async = true;
    script.onload = function () {
      init();
    };
    document.getElementsByTagName('head')[0].appendChild(script);
  }
})(window, document);


$(function(e) {

//ToggleList function
//   function toggle_list() {
//     $('.toggle-list .toggle-content').addClass('hide');
//     $(document).on('click', '.toggle-list .toggle-link', function () {
//       if ($(this).next().hasClass('hide')) {
//         $(this).next().slideDown(500);
//       } else {
//         $(this).next().slideUp(500);
//       }
//       $(this).parent().toggleClass('active');
//       $(this).next().toggleClass('hide');
//       return false;
//     });
//   }
//
//   var toggleList = document.querySelector('.toggle-list');
//
// //Init
//   if (toggleList) {
//     toggle_list();
//   }
/* 2.4. Toplink click
   ========================================================================== */

    jQuery(window).scroll(function () {
        if (jQuery(this).scrollTop() > 1000) {
            jQuery('.totop-link').fadeIn();
        } else {
            jQuery('.totop-link').fadeOut();
        }
    });

    jQuery('.totop-link').click(function () {
        jQuery('body,html').animate({
            scrollTop: 0
        }, 800);
        return false;
    });

/* 2.6. Preorder
   ========================================================================== */
    $('.show-hide').find('.hidden').hide();
    $('#inq-done-more').click(function() {
        if (!$(this).hasClass('less')) {
            $(this).parents('.show-hide').find('.hidden').slideDown(
                500);
            $(this).text('Read less').addClass('less');
        } else {
            $(this).parents('.show-hide').find('.hidden').slideUp(
                500);
            $(this).text('Read more').removeClass('less');
        }
    });
    var pl_panel = $('.plagcheckc aside#rightplagpanel').clone();
    $(pl_panel).removeAttr('id').appendTo('.plagcheckc').attr('id',
        'rightplagpanel_2');

/* 2.7. Parallax
   ========================================================================== */

    jQuery(document).scroll(function(){
        if( jQuery(window).outerWidth() > 1860 ){
            jQuery('.wrapper-box').css('top',-window.scrollY*1.5);
        }
    });

    if(navigator.userAgent.toLowerCase().indexOf('chrome')>-1){
        jQuery('.wrapper-container, .wrapper-box').css('transition-duration','.3s');
    }

/* 2.8. Main nav
   ========================================================================== */
	$('nav ol > li > a').each(function() {
	    if ($(this).attr('href') == window.location.pathname) {
	    	$(this).addClass('p_active');
	    }
	});

/* 2.9. Side menu
   ========================================================================== */
    jQuery("[data-toggle]").click(function(){
        var toggle_el=jQuery(this).data("toggle");
        jQuery(".wrapper-main").toggleClass("show-sidebar",0);
        jQuery(toggle_el).toggleClass("open-sidebar");
        jQuery(".wrapper-header").toggleClass("show-header",0);
    });
});

(function(window, document) {
  function init() {
    window.NotifyWidget({
      siteId: '133',
      container: '.NotifyWidget-banner'
    });
  }

  if (typeof window.NotifyWidget !== 'undefined') {
    init();
  } else {
    const script = document.createElement('script');
    script.src = '/assets/js/notifyWidget.min.js';
    script.async = true;
    script.onload = function () {
      init();
    };
    document.getElementsByTagName('head')[0].appendChild(script);
  }
})(window, document);
